<app-header></app-header>

<div class="wrapper">

  <app-estimate-box [isLoader]="isLoader"
    [submitBtnLabel]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'"
    (submitBtnClick)="saveParkingDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
    (forwardClick)="saveParkingDetails(null)" (backClick)="back()"></app-estimate-box>

  <div class="section_wrapper" style="margin-top: 20px;">
    <!-- stepper component -->
    <div class="dashBoard parking_detail_wrap">
      <app-stepper currentIndex="1.2" class="stepper"></app-stepper>
      <div class="parking_details w_100">
        <form class="parking_details_form">
          <h3 class="font_40_a32">Parking</h3>
          <div class=" form_section">
            <div>
              <mat-form-field class="genericTextFiled_h60 w_100 other_rooms_chips" appearance="fill">
                <mat-label>Parking Information<span style="color:red">*</span></mat-label>
                <mat-chip-grid #chipGrid aria-label="Parking informationselection">
                  <mat-chip-row *ngFor="let parking of ParkingFeatures" (removed)="remove(parking)">
                    {{parking}}
                    <button matChipRemove [attr.aria-label]="'remove ' + parking">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input placeholder="" #parkingInput [formControl]="parkingCtrl" [matChipInputFor]="chipGrid"
                  [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)" />
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                  <mat-option *ngFor="let parking of filteredParking | async" [value]="parking">
                    {{parking}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-error *ngIf="parkingFlag==true"> please select values(s) for parking information</mat-error>
            </div>
            <mat-form-field class="w_100 genericTextFiled_h60 ">
              <mat-label>Garage Spaces</mat-label>
              <input matInput type="number" min="0" placeholder="" name="garage-Spaces" [(ngModel)]="GarageSpaces">
            </mat-form-field>
            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Carport Spaces</mat-label>
              <input type="number" min="0" matInput placeholder="" name="CarPort-Spaces" [(ngModel)]="CarportSpaces">
            </mat-form-field>
            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Driveway Spaces</mat-label>
              <input matInput placeholder="" name="drive-way" [(ngModel)]="Driveway">
            </mat-form-field>
          </div>

          <!-- <div class="submit_buttons">
            <p class="save_text" *ngIf="historyState.parkingDetails">
              <span class="check_icon"><img src="../../../assets/icons/check_green.svg" alt="done"></span>
              Saved
            </p>

            <div class="buttons">

              <button class="back_button" *ngIf="!isLoader" (click)="saveParkingDetails()">Next</button>

              <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

              <app-green-button-v2 (click)="saveParkingDetails('skip')" label="Choose Plan"
                *ngIf="!isLoader && !historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

              <app-green-button-v2 (click)="saveParkingDetails('submit')" label="Submit Listing"
                *ngIf="!isLoader && historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

            </div>
          </div> -->

          <div class="mobile_submitButtons">
            <button class="arrowBtn leftArrow" (click)="back()">
              <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
            </button>
            <app-green-button-v2 class="SumbitBtnRes"
              (click)="saveParkingDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
              [label]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'" [buttonType]="'submit'"
              [width]="'136px'" [height]="'50px'">
            </app-green-button-v2>
            <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
            <button (click)="saveParkingDetails(null)" class="arrowBtn rightArrow">
              <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>